import React from 'react';
var HclLoader = function HclLoader() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loader-animated"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spinner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bounce1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bounce3"
  })));
};
export default HclLoader;